/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rte_Heading2Inputs */



/**
* | output |
* | --- |
* | "Heading 2" |
*
* @param {Rte_Heading2Inputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const rte_heading2 = /** @type {((inputs?: Rte_Heading2Inputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rte_Heading2Inputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Kop 2")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Titre 2")
	return /** @type {LocalizedString} */ ("Heading 2")
});